import React from "react";
import {
  SpinnerBar1,
  SpinnerBar2,
  SpinnerBar3,
  SpinnerBar4,
  SpinnerBar5,
  SpinnerBar6,
  SpinnerBar7,
  SpinnerBar8,
  SpinnerWrapper,
} from "./style";

export const Spinner = () => {
  return (
    <SpinnerWrapper>
      <SpinnerBar1 />
      <SpinnerBar2 />
      <SpinnerBar3 />
      <SpinnerBar4 />
      <SpinnerBar5 />
      <SpinnerBar6 />
      <SpinnerBar7 />
      <SpinnerBar8 />
    </SpinnerWrapper>
  );
};
